<div class="side-panel-container">
  <div class="info">
    <div class="title">
      <h3 i18n="@@NameTINChangeFormHeader" t="NameTINChangeFormHeader">Supplier Confirmation of Organizational Changes on File</h3>
    </div>
    <button tsl-icon-button size="large" (click)="close()">
      <tsl-icon>close</tsl-icon>
    </button>
  </div>
  <div class="task-container">
    <ng-dynamic-form #nameChangeForm *ngIf="formSchema" (onChangeField)="onDynamicChange($event)" [formData]="formData" [formSchema]="formSchema" [formMaxHeight]="false" 
    [translationData]="file"></ng-dynamic-form>
  </div>
  <div class="footer">
    <button tsl-button size="medium" color="black" outline (click)="close()" i18n="@@CLOSE" t="CLOSE">CLOSE</button>
    <button *ngIf="mode != 'view'" tsl-button size="medium" color="blue" filled (click)="submit()" i18n="@@SUBMIT" t="SUBMIT">SUBMIT</button>
  </div>
</div>
